import { GAME_SETTINGS } from "app/data/game-settings";
import remap from "app/utils/remap";

export default function getWordScore(
  baseScore: number,
  correctness: number
): number {
  // Fully correct
  if (correctness === 1) {
    return baseScore;
  }

  // Fully incorrect
  if (correctness < GAME_SETTINGS.matchCorrectThreshold) {
    return 0;
  }

  // Partially correct
  const maxPartialScore = baseScore - GAME_SETTINGS.partialCreditDeduction;
  const partialScore = remap(
    correctness,
    GAME_SETTINGS.matchCorrectThreshold,
    1,
    0,
    maxPartialScore
  )

  return Math.floor(partialScore);
}